import { SENSOR_NAMES } from '@linearb/linjs-common';
import { PROVIDERS_MAP } from 'common/constants/constants';
import { onDisconnectGitStream } from 'views/root/views/home/views/settings/views/RepositoriesV2/gitStreamIntegration/gitStream.service';
import { GitstreamGithubConnectionButton } from '../gitStreamIntegration/GitstreamGithubConnectionButton';
import GitStreamIntegrationButton from '../gitStreamIntegration/GitStreamIntegrationButton';
import AddRepositoryButton from './AddRepositoryButton';
import IntegrationMenu from './IntegrationMenu';
import IntegrationStatsChart from './IntegrationStatsChart/IntegrationStatsChart';
import { IntegrationDescription } from './titleSections';

/* istanbul ignore next */
// only relevant for gitlab
const getGitStreamSettings = ({
  sensor_name,
  isOnPrem,
  opaGitStreamInstalled,
  gitStreamEnabled
}) => {
  const isGitStreamInstalled = !!(isOnPrem && opaGitStreamInstalled); // <-- only relevant for on prem
  const isGitStreamEnabled = !!gitStreamEnabled;
  const gitStreamPrerequisites =
    sensor_name === PROVIDERS_MAP.gitlab.name.toLowerCase();
  const showNotConnectedToGitStream =
    isGitStreamInstalled && !isGitStreamEnabled && gitStreamPrerequisites;
  const showIsConnectedToGitStream =
    (isOnPrem ? isGitStreamInstalled : true) &&
    isGitStreamEnabled &&
    gitStreamPrerequisites;

  return { showNotConnectedToGitStream, showIsConnectedToGitStream };
};

const GitIntegrationTitle = ({
  sensor_name,
  gitIntegrations,
  updateSensorAuthorization,
  id: integrationId,
  name,
  stateOK,
  tableDataLength: repositoriesNumber,
  url,
  deleteGitIntegrationFF,
  account,
  canAddMoreRepos,
  toggleModal,
  repositories,
  createRepositories,
  setIsProcessingRepos,
  toggleSnackBar,
  isTeamLicense,
  getSensorAuthorizations,
  getRepositories,
  deleteSensorAuthorization,
  is_on_prem,
  gitIntegration = {} as any,
  prStats,
  autoRepoDiscoveryConfig,
  isMultiTokenEnabled,
  isRateLimitThresholdExceeded = false,
  readonly
}) => {
  const showConnectGitstreamGitlabButton =
    !readonly &&
    sensor_name === PROVIDERS_MAP.gitlab.name.toLowerCase() &&
    !is_on_prem;

  const showConnectGitstreamGithubButton =
    !readonly && sensor_name === PROVIDERS_MAP.github.name.toLowerCase() && url;

  const showConnectGitstreamBitbucketButton =
    !readonly &&
    sensor_name === PROVIDERS_MAP.bitbucket.displayName.toLowerCase() &&
    !url;

  const {
    gitstream_enabled: gitStreamEnabled,
    id: gitIntegrationId,
    opa_gitstream_installed: opaGitStreamInstalled
  } = gitIntegration;
  const shouldShowStatsChart = sensor_name === SENSOR_NAMES.GITHUB && stateOK;
  const { showNotConnectedToGitStream, showIsConnectedToGitStream } =
    getGitStreamSettings({
      sensor_name,
      isOnPrem: is_on_prem,
      opaGitStreamInstalled,
      gitStreamEnabled
    });

  return (
    <div className='w-full flex flex-row-end gap-1 items-center'>
      <IntegrationDescription
        sensor_name={sensor_name}
        name={name}
        integrationId={integrationId}
        gitIntegrations={gitIntegrations}
        updateSensorAuthorization={updateSensorAuthorization}
        stateOK={stateOK}
        account={account}
        url={url}
        repositoriesNumber={repositoriesNumber}
        toggleModal={toggleModal}
        showNotConnectedToGitStream={showNotConnectedToGitStream}
        showIsConnectedToGitStream={showIsConnectedToGitStream}
        autoRepoDiscoveryConfig={autoRepoDiscoveryConfig}
        isMultiTokenEnabled={isMultiTokenEnabled}
        isRateLimitThresholdExceeded={isRateLimitThresholdExceeded}
        readonly={readonly}
      />

      {shouldShowStatsChart && (
        <IntegrationStatsChart
          stats={prStats}
          isLoading={prStats === undefined}
        />
      )}

      {(showConnectGitstreamGitlabButton ||
        showConnectGitstreamBitbucketButton) && (
        <GitStreamIntegrationButton
          toggleSnackBar={toggleSnackBar}
          repositories={repositories}
          account={account}
          setIsProcessingRepos={setIsProcessingRepos}
          deleteSensorAuthorization={deleteSensorAuthorization}
          gitIntegrations={gitIntegrations}
          url={url}
          createRepositories={createRepositories}
          gitIntegration={gitIntegration}
          toggleModal={toggleModal}
          onDisconnect={() =>
            onDisconnectGitStream({
              sensorAuthorizationId: gitIntegrationId,
              toggleModal,
              getSensorAuthorizations,
              getRepositories,
              gitIntegration
            })
          }
        />
      )}

      {showConnectGitstreamGithubButton && (
        <GitstreamGithubConnectionButton
          gitIntegration={gitIntegration}
          toggleModal={toggleModal}
        />
      )}
      {!readonly && (
        <AddRepositoryButton
          stateOK={stateOK}
          canAddMoreRepos={canAddMoreRepos}
          isTeamLicense={isTeamLicense}
          toggleModal={toggleModal}
          repositories={repositories}
          createRepositories={createRepositories}
          account={account}
          setIsProcessingRepos={setIsProcessingRepos}
          toggleSnackBar={toggleSnackBar}
          integrationId={integrationId}
          name={name}
          sensor_name={sensor_name}
          url={url}
          gitIntegrations={gitIntegrations}
          getRepositories={getRepositories}
          deleteSensorAuthorization={deleteSensorAuthorization}
          deleteGitIntegrationFF={deleteGitIntegrationFF}
          is_on_prem={is_on_prem}
        />
      )}
      {!readonly && (
        <IntegrationMenu
          stateOK={stateOK}
          canAddMoreRepos={canAddMoreRepos}
          isTeamLicense={isTeamLicense}
          toggleModal={toggleModal}
          repositories={repositories}
          createRepositories={createRepositories}
          account={account}
          setIsProcessingRepos={setIsProcessingRepos}
          toggleSnackBar={toggleSnackBar}
          integrationId={integrationId}
          name={name}
          sensor_name={sensor_name}
          url={url}
          gitIntegrations={gitIntegrations}
          getSensorAuthorizations={getSensorAuthorizations}
          getRepositories={getRepositories}
          deleteSensorAuthorization={deleteSensorAuthorization}
          deleteGitIntegrationFF={deleteGitIntegrationFF}
          isMultiTokenEnabled={isMultiTokenEnabled}
          isOnPrem={is_on_prem}
        />
      )}
    </div>
  );
};

export default GitIntegrationTitle;
